import { parseUri } from '@hotjar/webapp/utils/urls';

export const getNextURL = (): string => {
  const currentUrl = new URL(window.location.href);
  const nextUrl = currentUrl.searchParams.get('next');

  if (!nextUrl) {
    return '/';
  }
  try {
    const urlParts = new URL(nextUrl, currentUrl.origin);
    if (urlParts.host.endsWith('.hotjar.com')) {
      return decodeURIComponent(nextUrl);
    }
  } catch {
    return '/';
  }
  return '/';
};

/**
 * Validates that the next URL is under HJ's domain.
 * @param url
 */
export const validateNextURL = (url: string): string => {
  const urlParts = parseUri(url);

  if (urlParts.host === '' || urlParts.host.indexOf('hotjar.com') > -1) {
    return url;
  }

  return '/';
};

/**
 * This function should be removed after full migrtion is done. It simply catches 2 issues that are
 * happening when the app sets the nextURL.
 * 2 abnormal issues happen:
 * - The next param is sometimes holding a full URL value including domain not just path name
 * - At points the next URL is being escaped twice which is very odd
 * Both scenarios are caught by this function.
 * @param nextUrl
 */
export function cropLoginPartFromNextURL(nextUrl = ''): string {
  if (nextUrl && window.location.origin) {
    let nextUrlObj;
    try {
      nextUrlObj = new URL(window.location.origin + nextUrl);
      const containsLoginInNextParam = nextUrlObj.pathname === '/login';

      if (containsLoginInNextParam) {
        const nextUrlAfterLogin = nextUrlObj.searchParams.get('next');
        return nextUrlAfterLogin || '/';
      }
      return nextUrl;
    } catch (typeError) {
      // At points next is being escaped twice, try unescaping twice
      try {
        const escaped = new URL(unescape(unescape(nextUrl)));
        if (escaped) {
          const escapedSearchParams = escaped.searchParams.toString();
          return `${escaped.pathname}${escapedSearchParams ? `?${escapedSearchParams}` : ''}`;
        }
      } catch (e) {
        // if this point is reached, nextUrl is irrecoverable
        return '';
      }
    }
    return nextUrlObj ? nextUrlObj.pathname : '';
  }
  return nextUrl;
}
